<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">红娘微信-通过码处展示</p>
      <div class="content-input">
<!--        <div class="content-input-item">-->
<!--          <label>展示位置：</label>-->
<!--          <el-select v-model="type" placeholder="Select" style="width: 6.4em">-->
<!--            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editMarriageDialog(-1)">新建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
            @cell-click="toggleSelection"
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="name" label="红娘名称" v-if="checkColList.indexOf('红娘名称') > -1" ></el-table-column>
          <el-table-column property="wechat" label="微信号" v-if="checkColList.indexOf('微信号') > -1" ></el-table-column>
          <el-table-column property="weight" label="权重" v-if="checkColList.indexOf('权重') > -1" ></el-table-column>
          <el-table-column property="todayNum" label="今日被复制数" v-if="checkColList.indexOf('今日被复制数') > -1" ></el-table-column>
          <el-table-column property="yesterdayNum" label="昨日被复制数" v-if="checkColList.indexOf('昨日被复制数') > -1" ></el-table-column>
          <el-table-column property="" label="被复制总数" v-if="checkColList.indexOf('被复制总数') > -1" class-name="cursor">
            <template #default="scope">
              <p style="color: #3a8ee6">{{ scope.row.totalNum }}</p>
            </template>
          </el-table-column>
          <el-table-column property="dayCopyCeiling" label="当天复制上限次数" v-if="checkColList.indexOf('当天复制上限次数') > -1"></el-table-column>
<!--          <el-table-column property="" label="展示位置" v-if="checkColList.indexOf('展示位置') > -1">-->
<!--            <template #default="scope">-->
<!--              {{scope.row.type == 0?'全部':scope.row.type == 1?'一对一脱单服务':scope.row.type == 2?'加微信领金币':''}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'已下架':scope.row.state == 1?'已上架':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editMarriageDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" type="success" v-if="scope.row.state == 0" @click="updateState(scope.$index, scope.row, 1)" v-loading="scope.row.updateLoading">上架</el-button>
                <el-button size="small" type="danger" v-if="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 0)" v-loading="scope.row.updateLoading">下架</el-button>
                <el-button size="small" type="primary" v-if="scope.row.defaultState == 0 && scope.row.state == 1" @click="updateDefaultState(scope.$index, scope.row, 1)" v-loading="scope.row.updateDefaultLoading">设为默认项</el-button>
                <p style="color: red;" v-if="scope.row.defaultState == 1">已设为默认项</p>
<!--                <el-button size="small" type="warning" v-if="scope.row.defaultState == 1" @click="updateDefaultState(scope.$index, scope.row, 0)">取消默认项</el-button>-->
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getThroughCodeWeChatPageList, updateThroughCodeWeChatState, updateThroughCodeWeChatDefaultState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import ThroughCodeEditDialog from "./components/ThroughCodeEditDialog";
import DatePickerRange from "../../components/DatePickerRange";
import UserLogDialog from "../../components/UserLog/UserLogDialog";
import ThroughCodeCopyNumDialog from "./components/ThroughCodeCopyNumDialog";

export default {
  name: "WeChatThroughCode",
  components: { DatePickerRange },
  data() {
    return {

      typeArray: [
        {label: '不限', value: -1},
        {label: '全部', value: 0},
        {label: '一对一脱单服务', value: 1},
        {label: '加微信领金币', value: 2},
      ],
      type: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '下架', value: 0},
        {label: '上架', value: 1},
      ],
      state: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //刷新组
      colList: ['创建时间', '红娘名称', '微信号', '权重', '今日被复制数', '昨日被复制数', '被复制总数', '当天复制上限次数', '展示位置', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      // this.type = -1;
      this.state = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      // param['type'] = this.type;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getThroughCodeWeChatPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editMarriageDialog(idx, row) {
      let _title = '';
      let codeForm = {}
      if (idx > -1) {
        _title = '编辑'
        codeForm = Object.assign({}, row);
      }else {
        _title = '新建'
      }
      Dialog.open({
        title: _title,
        component: ThroughCodeEditDialog,
        data: {
          codeForm: codeForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateThroughCodeWeChatState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    updateDefaultState(idx, row, state) {
      this.pageDataList[idx]['updateDefaultLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateThroughCodeWeChatDefaultState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateDefaultLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateDefaultLoading'] = false;
      })
    },

    toggleSelection(row, column, cell, event) {
      //更新用户日志
      if(column.label == '被复制总数') {
        Dialog.open({
          title: '被复制数量列表',
          component: ThroughCodeCopyNumDialog,
          data: {
            id: row.id,
            width: '600px'
          },
          close: () => {

          }
        })
      }
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
